import React from "react";
import { FaPhone, FaMapMarkerAlt, FaFacebookSquare } from "react-icons/fa";
import { MdOutlineWhatsapp } from "react-icons/md";
import { FaRegEnvelope, FaSquareInstagram } from "react-icons/fa6";
import { AiOutlineCopyrightCircle } from "react-icons/ai";
export const Footer = () => {
  return (
    <div className="app">
      <div className="social-media-section">
        <h4 className="social-media-title mb-3">NUESTRAS REDES</h4>
        <div className="social-media-row">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaSquareInstagram
              style={{ marginRight: "10px", fontSize: "2.5rem" }}
            />
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookSquare style={{ fontSize: "2.5rem" }} />
          </a>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-row">
            <p className="footer-item">
              <MdOutlineWhatsapp style={{ marginRight: "10px" }} />
              (2396) 432833
            </p>
          </div>
          <div className="footer-row">
            <p className="footer-item">
              <FaPhone style={{ marginRight: "10px" }} />
              (2396) 433171 - 479391
            </p>
          </div>
          <div className="footer-row">
            <p className="footer-item">
              <FaMapMarkerAlt style={{ marginRight: "1em" }} />
              Del Campo 348 - Pehuajó
            </p>
          </div>
          <div className="footer-row">
            <p className="footer-item">
              <FaRegEnvelope style={{ marginRight: "1em" }} />
              administracion@laboratoriocamusso.com.ar
            </p>
          </div>
        </div>
      </footer>

      <div className="footer-note">
        <a
          href="https://fasecuatro.com.ar/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-note-link"
        >
          Diseño y Desarrollo Fase Cuatro S.A.S.
        </a>
        <AiOutlineCopyrightCircle
          className="footer-note-copy-icon"
        
        />
      </div>
    </div>
  );
};
